import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal, Col } from "react-bootstrap";

const Textshow = (props) => {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props?.type}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row mb-5">
              {props?.type == "multiple" ? (
                <Col md={12}>
                  <div
                    style={{
                      padding: "20px",

                      margin: "0 auto",
                      fontFamily: "Arial, sans-serif",
                    }}
                  >
                    <h6>Multi - Cuisine Restaurant:</h6>
                    <p>To Get Live on APP, Please Complete: -</p>

                    <ol style={{ lineHeight: "2" }}>
                      <li>
                        Fill basic details of your hotel in 6 Step registration.
                      </li>
                      <li>Login with your ID & Password</li>
                      <li>Fill your Bank Account Details</li>
                      <li>On Dashboard (Left Side) – Select & Click Outlets</li>
                      <li>Select “All Outlet”</li>
                      <li>
                        Fill the Below Outlet Details:
                        <ul
                          style={{ listStyleType: "none", paddingLeft: "20px" }}
                        >
                          <li>✓ Menu</li>
                          <li>✓ Discounts</li>
                          <li>✓ Promotions & Parties (If Any)</li>
                          <li>✓ Activate Reward Program</li>
                          <li>✓ Fill Safety Measures</li>
                        </ul>
                      </li>
                    </ol>
                  </div>
                </Col>
              ) : (
                <Col md={12}>
                  <div
                    style={{
                      padding: "20px",
                      maxWidth: "600px",
                      margin: "0 auto",
                      fontFamily: "Arial, sans-serif",
                    }}
                  >
                    <h6>Standalone - Single Restaurant:</h6>
                    <p>To Get Live on APP, Please Complete: -</p>

                    <ol style={{ lineHeight: "2" }}>
                      <li>
                        Fill basic details of your Restaurant in 6 Step
                        Registration.
                      </li>
                      <li>Login with your ID & Password</li>
                      <li>Fill your Bank Account Details</li>
                      <li>
                        On Dashboard (Left Side) – Select Below
                        <ul
                          style={{
                            listStyleType: "none",
                            paddingLeft: "0",
                            marginTop: "10px",
                          }}
                        >
                          <li>
                            <strong>✓ Menu</strong>: Fill the Menu (Or upload
                            the Excel / PDF)
                          </li>
                          <li>
                            <strong>✓ Discount & Promotion</strong>: Fill
                            Discounts AND Fill Promotions & Parties (If Any)
                          </li>
                          <li>
                            <strong>✓ Rewards</strong>: Activate Reward Program
                          </li>
                          <li>
                            <strong>✓ Security Measures</strong>: Fill Safety
                            Measures
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </div>
                </Col>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Textshow;
